import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { useMetricsContext } from "src/Contexts/Metrics/ContextMetrics";
import { api } from "src/shared/setup/API/api";

export const UseTopProducer = () => {
  const { handleGetAlert } = useLayoutMainContext();

  const { filterHome, setValuesCardsTopsProducersHome } = useMetricsContext();

  const handleSubmit = () => {
    api
      .get(
        `/metrics/top-producers?start_date=${filterHome.startDate}&end_date=${filterHome.endDate}&tipo_contrato=${filterHome.tipo_contrato}`
      )
      .then(({ data }) => setValuesCardsTopsProducersHome(data.data))
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      );
  };

  return { handleSubmit };
};
